import { EntryRowProps, EntryRowTypeHelpers } from 'common/query-builder/query-entry-section/row-types/types';
import { EntryPart, MetricEntry } from 'common/query-builder/query-entry-section/types';
import * as BookmarkTypes from 'common/types/reports/bookmark';
import { getFormulaValidationError } from 'common/report/insights/contexts/formula-utils';
import { getShowSectionFromMetricsEntries } from 'common/report/insights/util/metrics';
import { hasValidMetricBookmarkShowClauses } from 'common/report/insights/contexts/validation';
import { NewMetricEntryRow } from './index';
import { getNewMetricEntry } from './utils';
export const helpers: EntryRowTypeHelpers<MetricEntry> = {
  component: NewMetricEntryRow,
  getNewEntry: () => {
    return getNewMetricEntry({
      isExpanded: true
    });
  },
  isPlaceholder: (props: EntryRowProps<MetricEntry>): boolean => {
    if (props.entry.type === BookmarkTypes.TopLevelMetricType.NewFormulaEntry) {
      const error = getFormulaValidationError({
        metric: props.entry,
        definition: props.entry.definition,
        globalMetrics: props.getEntries(false) as MetricEntry[]
      });
      return props.entry.definition === "" || Boolean(error);
    }
    const showClauses = getShowSectionFromMetricsEntries({
      entries: [props.entry]
    });
    return !hasValidMetricBookmarkShowClauses(showClauses.clauses);
  },
  getDefaultActiveEntryPart: () => {
    return EntryPart.Value;
  }
};